import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { getAcronym } from '@teem/helpers/functions';
import { PLAN_TYPES, SUBSCRIPTION_STATUS, USER_TYPE } from '@teem/constants/subscription';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { environment } from '@teem/environments/environment';
import { MixpanelService } from '@teem/services/mixpanel.service';
// import { FreePlanExpiredModalComponent } from '@teem/layouts/models/free-plan-expired/free-plan-expired-modal.component';

@Component({
  selector: 'upgrade-baner',
  templateUrl: './upgrade-baner.component.html',
  styleUrls: ['./upgrade-baner.component.css']
})
export class UpgradeBanerComponent implements OnInit {
  @Input() user;
  @Output() viewNotification: EventEmitter<any> = new EventEmitter();
  headerBar: boolean = true;
  freeTrailDays = environment.freeTrailDays;
  freeTrailStartDate = environment.freeTrailStartDate;
  date: Date;
  verifyDate: Date;
  currentRoute: string;
  activeInvoiceRoutes: string[] = ['/invoices', '/payments', '/expenses', '/quotations', '/taxes'];
  activeOrderRoutes: string[] = ['/orders', '/store', '/products', '/services'];
  // totalInvoices: number = 20;

  public notifications: Array<any> = [];
  public unreadNotificationsCount: number = 0;


  @Input('notifications')
  set setNotifications(value: any) {
    this.notifications = value ? value : [];
  }

  @Input('unreadNotificationsCount')
  set notificationsCount(value: number) {
    this.unreadNotificationsCount = value ? value : 0;
  }

  locale: string = 'en';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private modalService: NgbModal,
    private mixpanelService: MixpanelService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this.router.url;
        console.log(this.currentRoute);
      }
    });
  }

  ngOnInit(): void {
    this.locale = (window as any).LOCALE;
  }

  get totalInvoices() {
    if (this.planName == 'invoice-basic')  {
      return 10;
    } else if (this.planName == 'invoice-pro') {
      return 100;
    }
    return 20;
  }

  get remaningDaysTrialPlan() {
    if (this.user?.subscription?.remaining_days < 0) {
      this.headerBar = false;
    }
    return this.user?.subscription?.remaining_days;

    this.verifyDate = new Date(this.user.verified_at);
    this.date = new Date(this.freeTrailStartDate);
    this.date.setDate(this.date.getDate() + this.freeTrailDays);
    let date1: any = new Date(this.date);
    if (this.verifyDate > new Date(this.freeTrailStartDate)) {
      this.verifyDate.setDate(this.verifyDate.getDate() + this.freeTrailDays);
      date1 = new Date(this.verifyDate);
    }
    let date2: any = new Date();
    let diffDays: any = Math.floor((date1 - date2) / (1000 * 60 * 60 * 24));
    if (diffDays < 0) {
      this.headerBar = false;
    }
    return diffDays;
  }

  get userAcronym() {
    return this.user ? getAcronym(this.user.first_name + ' ' + this.user.last_name) : '';
  }

  isTrialPlan() {
    return this.user?.subscription?.on_free_trial;
  }

  isSettlement() {
    if (this.user && this.user.is_myfatoorah_active)
      return true;
    else
      return false;
  }

  isBasicPlan() {
    if (this.user && this.user.subscription && [SUBSCRIPTION_STATUS.active].indexOf(this.user.subscription.subscription_status) != -1)
      return this.user.subscription.subscription_plan == PLAN_TYPES.basic;
    else
      false;
  }

  closeHeaderBar() {
    // Mixpanel event sub_upgrade_banner_close_click
    let userProperties = this.mixpanelService.getUserProperties(this.user);
    let trackProperties = this.mixpanelService.getTrackProperties(this.user);
    let combinedProperties = {
      ...userProperties,
      ...trackProperties
    };
    // this.mixpanelService.setUserProperties(userProperties);
    this.mixpanelService.track('sub_upgrade_banner_close_click', combinedProperties);
    if (this.user?.billing_experimente_data?.name) {
      this.mixpanelService.unionUserProperties({ 'experiments': this.user.billing_experimente_data.name })
    }
    this.headerBar = !this.headerBar;
  }

  isProPlan() {
    if (this.user && this.user.subscription && [SUBSCRIPTION_STATUS.active].indexOf(this.user.subscription.subscription_status) != -1)
      return this.user && this.user.subscription && this.user.subscription.subscription_plan == PLAN_TYPES.pro;
    else
      false;
  }

  isIndividualPlan() {
    if (this.user && this.user.subscription && [SUBSCRIPTION_STATUS.active].indexOf(this.user.subscription.subscription_status) != -1)
      return this.user.subscription.subscription_plan == PLAN_TYPES.individual;
    else
      false;
  }

  isProfessionalPlan() {
    if (this.user && this.user.subscription && [SUBSCRIPTION_STATUS.active].indexOf(this.user.subscription.subscription_status) != -1)
      return this.user.subscription.subscription_plan == PLAN_TYPES.professional;
    else
      false;
  }

  isBusinessPlan() {
    if (this.user && this.user.subscription && [SUBSCRIPTION_STATUS.active].indexOf(this.user.subscription.subscription_status) != -1)
      return this.user.subscription.subscription_plan == PLAN_TYPES.business;
    else
      false;
  }

  isUser() {
    if (this.user && this.user?.user_type)
      return this.user?.user_type == USER_TYPE.user;
    else
      false;
  }

  isAdmin() {
    if (this.user && this.user?.user_type)
      return (this.user?.user_type == USER_TYPE.admin || this.user?.user_type == USER_TYPE.super_admin);
    else
      false;
  }

  isSuperAdmin() {
    if (this.user && this.user?.user_type)
      return this.user?.user_type == USER_TYPE.super_admin;
    else
      false;
  }

  get pendingInvoiceCount() {
    if (this.user && this.user.permissions && this.user.permissions.pending_invoices)
      return this.user.permissions.pending_invoices;

    return 0;
  }

  get allowCreateInvoice() {
    if (this.user && this.user.permissions && this.user.permissions.create_invoice)
      return this.user.permissions.create_invoice;

    return false;
  }

  get pendingPaymentCount() {
    return this.user?.pending_invoices;
  }

  get planName() {
    // return 'basic';
    if (this.user?.subscription?.original_subscription_plan == 'free') {
      return 'free';
    }
    return this.user && this.user.subscription ? this.user.subscription.subscription_plan : '';
  }

  get planNameTrans() {
    let plan = this.planName.replace(/-/g, '_')  + '_plan';
    return i18n.t('plan.'+plan);
  }

  get paymentBy() {
    return this.user?.subscription?.payment_by;
  }

  get originalPlanName() {
    return this.user && this.user.subscription ? this.user.subscription.original_subscription_plan : 'free';
  }

  navigateToPlans() {
    // Mixpanel event sub_upgrade_banner_click
    let userProperties = this.mixpanelService.getUserProperties(this.user);
    let trackProperties = this.mixpanelService.getTrackProperties(this.user);
    let combinedProperties = {
      ...userProperties,
      ...trackProperties
    };
    // this.mixpanelService.setUserProperties(userProperties);
    this.mixpanelService.track('sub_upgrade_banner_click', combinedProperties);
    if (this.user?.billing_experimente_data?.name) {
      this.mixpanelService.unionUserProperties({ 'experiments': this.user.billing_experimente_data.name })
    }
    if (this.user?.billing_experimente_data?.is_experiment == 1) {
      this.router.navigate(['/billing']);
    } else {
      
      this.router.navigate(['/setting'], { queryParams: { 'tab': 'plans' } });
    }
  }

  navigateToBilling() {
    // Mixpanel event sub_page_click
    let userProperties = this.mixpanelService.getUserProperties(this.user);
    let trackProperties = this.mixpanelService.getTrackProperties(this.user);

          let combinedProperties = {
            ...userProperties,
            ...trackProperties
          };
    this.mixpanelService.setUserProperties(userProperties);
    this.mixpanelService.track('sub_page_click', combinedProperties);
    if (this.user?.billing_experimente_data?.name) {
      this.mixpanelService.unionUserProperties({ 'experiments': this.user.billing_experimente_data.name })
    }
    this.router.navigate(['/billing']);
   
  }

  // isEmpty(obj: any): boolean {
  // 	return obj == null || Object.keys(obj).length === 0;
  // }
  upgradeToCreateInvoice() {
    Swal.fire(i18n.invoice.upgrade_account_to_create_more_invoice, "", 'warning');
    return;
  }

  navigateToInvoices() {
    if (this.router.url == '/invoices') {
      window.location.reload();
    } else {
      this.router.navigateByUrl('/invoices');
    }

  }
}
